<script>
import EventForm from '@events/components/event-form.vue'
import Layout from '@layouts/loggedin.vue'
import axios from 'axios'
import store from '@state/store'
import mapKeys from 'lodash/mapKeys'
import snakeCase from 'lodash/snakeCase'
import { format } from 'date-fns/fp'

export default {
  components: {
    Layout,
    EventForm,
  },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    formatPayload(formater, payload) {
      return mapKeys(payload, (value, key) => formater(key))
    },
    onSaveClick(payload) {
      this.isLoading = true
      const eventForm = this.formatPayload(snakeCase, payload)
      eventForm.start = format('yyyy-MM-dd kk:mm:ss', eventForm.start)
      eventForm.end = format('yyyy-MM-dd kk:mm:ss', eventForm.end)

      return axios
        .post(`/api/v1/opportunity`, eventForm)
        .then(({ data }) => {
          return store
            .dispatch('events/setEventDetails', {
              id: data.id,
              eventDetails: data,
            })
            .then(() => data)
        })
        .then((data) => {
          return this.$router.push({
            name: 'editEventSettings',
            params: { companyId: this.companyId, eventId: data.id },
          })
        })
        .then(() => {
          alert('Event have been successfully registered!')
        })
        .catch((error) => {
          console.error('Error creating event:', error)
          alert('Something went wrong.')
        })
        .finally(() => (this.isLoading = false))
    },
    onCancelClick() {
      this.$router.push({
        name: 'company',
        params: { companyId: this.companyId },
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="text-xl px-7.5 py-3.5 bg-white">
      <span class="">Volunteer Opportunities</span>
      <span class="breadcrumb-separator">></span>
      <span class="text-blue">New Volunteer Opportunity</span>
    </div>

    <div
      class="bg-white rounded-xl shadow-box overflow-hidden m-4.5 py-9 px-29"
    >
      <EventForm
        :is-loading="isLoading"
        @save="onSaveClick"
        @cancel="onCancelClick"
        @loading="(value) => (isLoading = value)"
      />
    </div>
  </Layout>
</template>
